var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTree2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#449e38",
    d: "M4 0h5M3 1h3m1 0h4M1 2h2m1 0h2m1 0h3M1 3h2m1 0h1m1 0h1m1 0h1M0 4h1m1 0h2m1 0h1M5 6h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#408e3d",
    d: "M2 1h1m3 0h1M3 2h1m2 0h1m3 0h1M3 3h1m1 0h1m1 0h1m1 0h1M1 4h1m2 0h1m2 0h3M0 5h4m1 0h2M2 6h1m0 1h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#347231",
    d: "M11 2h1m-2 1h2M6 4h1m3 0h2M4 5h1m2 0h1m1 0h2M1 6h1m2 0h1m1 0h2m1 0h2M2 7h1m2 0h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7f3b2c",
    d: "M8 5h1M3 6h1m4 0h1M8 7h1M7 8h2M5 9h2m-1 1h2m0 1h1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8c542c",
    d: "M4 7h1m1 0h1M5 8h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6d2928",
    d: "M5 10h1m-2 1h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree2);
export default __webpack_public_path__ + "static/media/tree2.9498d8b01a615661253d4ec2811b2f90.svg";
export { ForwardRef as ReactComponent };